import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { WebTableLinkedService } from 'app/model/linkedservice/web-table.linkedservice';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(WebTableLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                url: '*',
                authenticationType: '*'
            }
        }
    }
})
export class WebTableLinkedServiceAdapter extends LinkedServiceAdapter<WebTableLinkedService> {
    protected modelConstructor(): new () => WebTableLinkedService {
        return WebTableLinkedService;
    }

    protected model(): IModel {
        return WebTableLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: WebTableLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.WebLinkedService;
        properties.type = Metamodel.modelFor(WebTableLinkedService).name;

        properties.typeProperties = {
            url: linkedService.url,
            authenticationType: linkedService.authenticationType
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: WebTableLinkedService): Promise<WebTableLinkedService> {
        const properties = linkedServiceResource.properties as Model.WebLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.WebLinkedServiceTypeProperties = properties.typeProperties;

        linkedService.url = typeProperties.url;
        linkedService.authenticationType = typeProperties.authenticationType;

        return linkedService;
    }
}
